var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "sui-container",
    [
      _c(
        "div",
        { staticClass: "manager" },
        [
          _c(
            "div",
            { staticClass: "title" },
            [
              _c(
                "sui-header",
                { tag: "h3", staticStyle: { "font-weight": "lighter" } },
                [_vm._v("Fee Schedules")]
              ),
            ],
            1
          ),
          _c("sui-input", {
            attrs: {
              placeholder: "Search list...",
              icon: "search",
              "icon-position": "left",
            },
            model: {
              value: _vm.searchPhrase,
              callback: function ($$v) {
                _vm.searchPhrase = $$v
              },
              expression: "searchPhrase",
            },
          }),
          _c(
            "div",
            { staticClass: "actions" },
            [
              _c("sui-button", {
                attrs: {
                  basic: "",
                  size: "tiny",
                  content: "New Fee Schedule",
                  color: "grey",
                },
                on: { click: _vm.handleNewFeeSchedule },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("FeeScheduleList", {
        attrs: { feeSchedules: _vm.feeSchedules },
        on: {
          handleViewFeeSchedule: _vm.handleViewFeeSchedule,
          handleEditFeeSchedule: _vm.handleEditFeeSchedule,
          showDeleteWarning: _vm.showDeleteWarning,
        },
      }),
      _c("Modal", {
        ref: "modal",
        attrs: {
          title: _vm.title,
          feeSchedule: _vm.feeSchedule,
          firms: _vm.firms,
          financialAdvisors: _vm.financialAdvisors,
          reset: _vm.reset,
        },
      }),
      _c("DeleteWarning", {
        ref: "deleteWarningModal",
        on: { handleDelete: _vm.handleDeleteFeeSchedule },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }